import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild} from '@angular/core';
import {DcpProductUtilitiesService} from '@app/product/services/dcp-product-utilities.service';
import {EntryGroupService} from '@app/product/services/entry-group.service';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';
import {DcpEntryGroup, DcpGlobalMessageService} from '@dcp/configurator';
import {Cart, OrderEntry} from '@spartacus/cart/base/root';
import {CheckoutEntryValidationService} from '../../services/checkout-entry-validation.service';
import {RefreshCartService} from '../../services/refresh-cart.service';

@Component({
  selector: 'dcp-invalid-cart-entry-message',
  templateUrl: './invalid-cart-entry-message.component.html',
})
export class InvalidCartEntryMessageComponent implements AfterViewInit, OnDestroy {

  @ViewChild('errorTemplate', {static: false}) errorTemplate: TemplateRef<any>;
  @Output() indicatorChange = new EventEmitter<boolean>();

  entries: OrderEntry[];
  showSpinner: boolean = false;

  constructor(
    public productUtilitiesService: DcpProductUtilitiesService,
    private refreshCartService: RefreshCartService,
    private dcpGlobalMessageService: DcpGlobalMessageService,
    private checkoutEntryValidationService: CheckoutEntryValidationService,
    private dcpSupportFormService: DcpSupportFormService,
    private entryGroupService: EntryGroupService
  ) {
  }

  @Input() set cart(cart: Cart) {
    this.entries = this.getProductEntriesWithErrors(cart);
    this.showSpinner = false;
    this.addErrorMessage(this.entries);
    this.triggerIndicator();
  }

  ngAfterViewInit() {
    this.addErrorMessage(this.entries);
  }

  ngOnDestroy() {
    this.dcpGlobalMessageService.setActiveTemplate(null);
  }

  triggerIndicator() {
    this.indicatorChange.emit(this.showSpinner);
  }

  addErrorMessage(entries: OrderEntry[]) {
    if (entries?.length && this.errorTemplate) {
      this.dcpGlobalMessageService.setActiveTemplate(this.errorTemplate);
    } else {
      this.dcpGlobalMessageService.setActiveTemplate(null);
    }
  }

  reloadCart() {
    this.showSpinner = true;
    this.refreshCartService.refreshCart();
    this.triggerIndicator();
  }

  contactSupport() {
    this.dcpSupportFormService.open();
  }

  /**
   * Returns product entries that contains errors or is linked to
   * a derivative with errors.
   *
   * @param cart Cart of the current user.
   */
  getProductEntriesWithErrors(cart: Cart): OrderEntry[] {
    const rootEntriesWithErrors: DcpEntryGroup[] = this.getRootEntriesWithErrors(cart.entryGroups);
    return this.entryGroupService.getOrderEntriesByBundleType(rootEntriesWithErrors);
  }

  /**
   * Looks for invalid entries within a root group and
   * returns the root groups that contain derivatives or products with errors.
   *
   * @param entryGroups list of entryGroups to search for invalid entries in.
   */
  getRootEntriesWithErrors(entryGroups: DcpEntryGroup[]): DcpEntryGroup[] {
    const rootEntries: DcpEntryGroup[] = this.entryGroupService.collectEntryGroups(
      this.entryGroupService.isRoot, entryGroups
    );
    return rootEntries.filter(re => {
      const orderEntries: OrderEntry[] = this.entryGroupService.getOrderEntriesByBundleType(
        re.entryGroups, eg => !!eg.entries?.length
      );
      return this.checkoutEntryValidationService.containsInvalidEntries(orderEntries);
    });
  }
}
